import { FirebaseFirestoreDatasource } from 'data/datasources/firebase/firestore-datasource';
import { FirebaseFirestoreDatasourceImp } from 'datasources/firebase/firestore-datasource';

export const makeFirebaseFirestoreDatasource = (): FirebaseFirestoreDatasource => {
  return new FirebaseFirestoreDatasourceImp();
};
